import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { FiTrash2, FiHeart, FiShoppingBag } from 'react-icons/fi';
import ApiCheckout from '../../adapters/apiCheckout';

// Automotive images
import ImgCarOil from "../../assets/images/car_oil.jpg";
import ImgTransFluid from "../../assets/images/transmission_fluid.jpg";
import ImgCarCoolant from "../../assets/images/car_coolant.jpg";
import ImgGiftCard20 from "../../assets/images/car_giftcard_20.png";
import ImgGiftCard50 from "../../assets/images/car_giftcard_50.png";
import ImgGiftCard100 from "../../assets/images/car_giftcard_100.png";

// Airport parking images
import ImgAirport1 from "../../assets/images/airport/airport_img_1.png";
import ImgAirport2 from "../../assets/images/airport/airport_img_2.png";
import ImgAirport3 from "../../assets/images/airport/airport_img_3.png";
import ImgAirport4 from "../../assets/images/airport/airport_img_4.png";
import ImgAirport5 from "../../assets/images/airport/airport_img_5.png";
import ImgAirport6 from "../../assets/images/airport/airport_img_6.png";

// Offstreet parking images
import ImgOffstreeParking1 from "../../assets/images/parking/parking_img_1.png";

// Burger images
import ImgBurger1 from "../../assets/images/burger/burger_img_1.jpeg";
import ImgBurger2 from "../../assets/images/burger/burger_img_2.jpeg";
import ImgBurger3 from "../../assets/images/burger/burger_img_3.jpeg";
import ImgBurger4 from "../../assets/images/burger/burger_img_4.jpeg";
import ImgBurger5 from "../../assets/images/burger/burger_img_5.jpeg";
import ImgBurger6 from "../../assets/images/burger/burger_img_6.jpeg";

// Fashion images
import ImgFashion1 from "../../assets/images/fashion/fashion_img_1.jpeg";
import ImgFashion2 from "../../assets/images/fashion/fashion_img_2.jpeg";
import ImgFashion3 from "../../assets/images/fashion/fashion_img_3.jpeg";
import ImgFashion4 from "../../assets/images/fashion/fashion_img_4.jpeg";
import ImgFashion5 from "../../assets/images/fashion/fashion_img_5.jpeg";
import ImgFashion6 from "../../assets/images/fashion/fashion_img_6.jpeg";

// Cosmetics images
import ImgCosmetics1 from "../../assets/images/cosmetics/cosmetics_img_1.jpeg";
import ImgCosmetics2 from "../../assets/images/cosmetics/cosmetics_img_2.jpeg";
import ImgCosmetics3 from "../../assets/images/cosmetics/cosmetics_img_3.jpeg";
import ImgCosmetics4 from "../../assets/images/cosmetics/cosmetics_img_4.jpeg";
import ImgCosmetics5 from "../../assets/images/cosmetics/cosmetics_img_5.jpeg";

// Electronics images
import ImgElectronics1 from "../../assets/images/electronics/electronics_img_1.jpeg";
import ImgElectronics2 from "../../assets/images/electronics/electronics_img_2.jpeg";
import ImgElectronics3 from "../../assets/images/electronics/electronics_img_3.jpeg";
import ImgElectronics4 from "../../assets/images/electronics/electronics_img_4.jpeg";
import ImgElectronics5 from "../../assets/images/electronics/electronics_img_5.jpeg";

// Home images
import ImgHome1 from "../../assets/images/home/home_img_1.jpeg";
import ImgHome2 from "../../assets/images/home/home_img_2.jpeg";
import ImgHome3 from "../../assets/images/home/home_img_3.jpeg";
import ImgHome4 from "../../assets/images/home/home_img_4.jpeg";
import ImgHome5 from "../../assets/images/home/home_img_5.jpeg";

// Pets images
import ImgPets1 from "../../assets/images/pets/pets_img_1.jpeg";
import ImgPets2 from "../../assets/images/pets/pets_img_2.jpeg";
import ImgPets3 from "../../assets/images/pets/pets_img_3.jpeg";
import ImgPets4 from "../../assets/images/pets/pets_img_4.jpeg";
import ImgPets5 from "../../assets/images/pets/pets_img_5.jpeg";

// Business configurations with sample product data
const BUSINESS_CONFIGS = {
  parking: {
    businessName: "Airport Parking",
    headerText: "Secure your spot",
    badgeText: "Airport Parking",
    headingPrefix: "Your Parking",
    headingHighlight: "Options",
    primaryColor: "#92328E",
    secondaryColor: "#9CA3AF",
    logoUrl: "https://theneo-prod-public.s3.us-east-1.amazonaws.com/4c54b8fb-0f98-48e0-befd-4aafb3639c1c.svg",
    footerText: "Prices include applicable taxes. Bookings are non-transferable. Please review our cancellation policy.",
    products: [
      {
        id: 1,
        name: "Off-Site Economy",
        description: "$100/day - Free shuttle - Open air - Book 2hrs before entry",
        price: 100.00,
        imageUrl: ImgAirport1
      },
      {
        id: 2,
        name: "P3 Long Term Car Park",
        description: "$125/day - 10 min walk - On-site - Free luggage trolleys",
        price: 125.00,
        imageUrl: ImgAirport2
      },
      {
        id: 3,
        name: "P2 Outdoor Car Park",
        description: "$150/day - 5-7 min walk - Behind terminal - Trolleys available",
        price: 150.00,
        imageUrl: ImgAirport3
      },
      {
        id: 4,
        name: "P1 Terminal Car Park",
        description: "$200/day - 2-5 min walk - Undercover - Premium location",
        price: 200.00,
        imageUrl: ImgAirport4
      },
      {
        id: 5,
        name: "Valet Parking",
        description: "$250/day - 1 min - Park at terminal door - Staff handle your car",
        price: 250.00,
        imageUrl: ImgAirport5
      },
      {
        id: 6,
        name: "Long Stay Weekly",
        description: "$100/day - Shuttle service - Secure lot - CCTV monitored",
        price: 100.00,
        imageUrl: ImgAirport6
      }
    ]
  },
  automotive: {
    businessName: "EnergizeX",
    headerText: "Energize your future",
    primaryColor: "#3B82F6",
    secondaryColor: "#8f8f8f",
    logoUrl: "https://theneo-prod-public.s3.us-east-1.amazonaws.com/4c54b8fb-0f98-48e0-befd-4aafb3639c1c.svg",
    footerText: "Prices include applicable taxes. Baggage fees may apply. Please review our cancellation policy before booking.",
    products: [
      {
        id: 1,
        name: "Car Oil",
        description: "Lubricates, Cleans, and Protects Engine",
        price: 46.00,
        imageUrl: ImgCarOil
      },
      {
        id: 2,
        name: "Transmission Fluid",
        description: "Ensures Smooth Gear Shifts and Optimal Performance",
        price: 31.00,
        imageUrl: ImgTransFluid
      },
      {
        id: 3,
        name: "Car Coolant",
        description: "Prevents Overheating and Protects Engine",
        price: 26.00,
        imageUrl: ImgCarCoolant
      },
      {
        id: 4,
        name: "Gift Card",
        description: "Spend at any store",
        price: 20.00,
        imageUrl: ImgGiftCard20
      },
      {
        id: 5,
        name: "Gift Card",
        description: "Spend at any store",
        price: 50.00,
        imageUrl: ImgGiftCard50
      },
      {
        id: 6,
        name: "Gift Card",
        description: "Spend at any store",
        price: 100.00,
        imageUrl: ImgGiftCard100
      }
    ]
  },
  
  burgers: {
    businessName: "Burger Paradise",
    headerText: "Fresh burgers made to order",
    primaryColor: "#DC2626",
    secondaryColor: "#F59E0B",
    logoUrl: "https://theneo-prod-public.s3.us-east-1.amazonaws.com/4c54b8fb-0f98-48e0-befd-4aafb3639c1c.svg",
    footerText: "Fresh ingredients daily. Free delivery on orders over $25.",
    products: [
      {
        id: 1,
        name: "Classic Cheeseburger",
        description: "Beef patty with cheddar cheese, lettuce, tomato, onion",
        price: 13.00,
        imageUrl: ImgBurger1
      },
      {
        id: 2,
        name: "BBQ Bacon Burger",
        description: "Beef patty with bacon, BBQ sauce, onion rings",
        price: 16.00,
        imageUrl: ImgBurger2
      },
      {
        id: 4,
        name: "Crispy Chicken Sandwich",
        description: "Breaded chicken breast with pickle, mayo, lettuce",
        price: 12.00,
        imageUrl: ImgBurger3
      },
      {
        id: 5,
        name: "Potato Fries",
        description: "Crispy potato fries with chipotle dipping sauce",
        price: 7.00,
        imageUrl: ImgBurger4
      },
      {
        id: 6,
        name: "Chocolate Milkshake",
        description: "Rich chocolate milkshake topped with whipped cream",
        price: 6.00,
        imageUrl: ImgBurger5
      },
      {
        id: 8,
        name: "Onion Rings",
        description: "Beer-battered onion rings served with ranch dipping sauce",
        price: 8.00,
        imageUrl: ImgBurger6
      }
    ]
  },
  
  fashion: {
    businessName: "StyleHub",
    headerText: "Express your unique style",
    primaryColor: "#EC4899",
    secondaryColor: "#9CA3AF",
    logoUrl: "https://theneo-prod-public.s3.us-east-1.amazonaws.com/4c54b8fb-0f98-48e0-befd-4aafb3639c1c.svg",
    footerText: "Free shipping on orders over $75. Easy returns within 30 days.",
    products: [
      {
        id: 1,
        name: "Designer Jeans",
        description: "Premium denim with perfect fit and comfort",
        price: 90.00,
        imageUrl: ImgFashion1
      },
      {
        id: 2,
        name: "Cotton T-Shirt",
        description: "Soft, breathable fabric for everyday wear",
        price: 25.00,
        imageUrl: ImgFashion2
      },
      {
        id: 3,
        name: "Leather Jacket",
        description: "Genuine leather with modern styling",
        price: 200.00,
        imageUrl: ImgFashion3
      },
      {
        id: 4,
        name: "Running Shoes",
        description: "Lightweight and comfortable athletic footwear",
        price: 80.00,
        imageUrl: ImgFashion4
      },
      {
        id: 5,
        name: "Wool Sweater",
        description: "Cozy merino wool blend for cold weather",
        price: 65.00,
        imageUrl: ImgFashion5
      },
      {
        id: 6,
        name: "Summer Dress",
        description: "Flowy fabric perfect for warm weather",
        price: 55.00,
        imageUrl: ImgFashion6
      }
    ]
  },
  
  beauty: {
    businessName: "Your Beauty",
    headerText: "Enhance your natural beauty",
    primaryColor: "#F59E0B",
    secondaryColor: "#6B7280",
    logoUrl: "https://theneo-prod-public.s3.us-east-1.amazonaws.com/4c54b8fb-0f98-48e0-befd-4aafb3639c1c.svg",
    footerText: "Cruelty-free products. 90-day satisfaction guarantee.",
    products: [
      {
        id: 1,
        name: "Foundation",
        description: "Full coverage, long-lasting liquid foundation",
        price: 42.00,
        imageUrl: ImgCosmetics1
      },
      {
        id: 2,
        name: "Lipstick Set",
        description: "5 gorgeous shades in matte finish",
        price: 36.00,
        imageUrl: ImgCosmetics2
      },
      {
        id: 3,
        name: "Eye Palette",
        description: "12 highly pigmented eyeshadow colors",
        price: 29.00,
        imageUrl: ImgCosmetics3
      },
      {
        id: 4,
        name: "Moisturizer",
        description: "Hydrating face cream with SPF 30",
        price: 39.00,
        imageUrl: ImgCosmetics4
      },
      {
        id: 5,
        name: "Mascara",
        description: "Volumizing and lengthening formula",
        price: 23.00,
        imageUrl: ImgCosmetics5
      }
    ]
  },
  
  electronics: {
    businessName: "TechSphere",
    headerText: "Innovation at your fingertips",
    primaryColor: "#1F2937",
    secondaryColor: "#6B7280",
    logoUrl: "https://theneo-prod-public.s3.us-east-1.amazonaws.com/4c54b8fb-0f98-48e0-befd-4aafb3639c1c.svg",
    footerText: "1-year warranty on all products. Tech support available 24/7.",
    products: [
      {
        id: 1,
        name: "Wireless Headphones",
        description: "Premium sound quality with noise cancellation",
        price: 150.00,
        imageUrl: ImgElectronics1
      },
      {
        id: 2,
        name: "Smartphone Case",
        description: "Protective case with wireless charging support",
        price: 30.00,
        imageUrl: ImgElectronics2
      },
      {
        id: 3,
        name: "Portable Charger",
        description: "10000mAh fast charging power bank",
        price: 40.00,
        imageUrl: ImgElectronics3
      },
      {
        id: 4,
        name: "Bluetooth Speaker",
        description: "Waterproof speaker with 12-hour battery",
        price: 80.00,
        imageUrl: ImgElectronics4
      },
      {
        id: 5,
        name: "Smart Watch",
        description: "Fitness tracking with heart rate monitor",
        price: 200.00,
        imageUrl: ImgElectronics5
      }
    ]
  },
  
  home: {
    businessName: "HomeHub",
    headerText: "Create your perfect space",
    primaryColor: "#059669",
    secondaryColor: "#6B7280",
    logoUrl: "https://theneo-prod-public.s3.us-east-1.amazonaws.com/4c54b8fb-0f98-48e0-befd-4aafb3639c1c.svg",
    footerText: "Free assembly service. 60-day return policy.",
    products: [
      {
        id: 1,
        name: "Throw Pillow Set",
        description: "Set of 3 decorative pillows",
        price: 50.00,
        imageUrl: ImgHome1
      },
      {
        id: 2,
        name: "Scented Candle",
        description: "Vanilla lavender blend, 40-hour burn time",
        price: 25.00,
        imageUrl: ImgHome2
      },
      {
        id: 3,
        name: "Wall Art Print",
        description: "Modern abstract design, ready to frame",
        price: 35.00,
        imageUrl: ImgHome3
      },
      {
        id: 4,
        name: "Area Rug",
        description: "Soft geometric pattern, machine washable",
        price: 90.00,
        imageUrl: ImgHome4
      },
      {
        id: 5,
        name: "Table Lamp",
        description: "LED desk lamp with adjustable brightness",
        price: 65.00,
        imageUrl: ImgHome5
      }
    ]
  },
  
  offstreetParking: {
    businessName: "Offstreet Parking",
    headerText: "Convenient city parking",
    badgeText: "Offstreet Parking",
    headingPrefix: "Your Offstreet",
    headingHighlight: "Parking",
    primaryColor: "#4F46E5",
    secondaryColor: "#9CA3AF",
    logoUrl: "https://theneo-prod-public.s3.us-east-1.amazonaws.com/4c54b8fb-0f98-48e0-befd-4aafb3639c1c.svg",
    footerText: "Prices include applicable taxes. Bookings are non-transferable.",
    hourlyRate: 5.00,
    products: []
  },

  pets: {
    businessName: "PawPals",
    headerText: "Everything for your furry friends",
    primaryColor: "#7C3AED",
    secondaryColor: "#6B7280",
    logoUrl: "https://theneo-prod-public.s3.us-east-1.amazonaws.com/4c54b8fb-0f98-48e0-befd-4aafb3639c1c.svg",
    footerText: "Vet-approved products. Subscribe & save 15%.",
    products: [
      {
        id: 1,
        name: "Premium Dog Food",
        description: "Grain-free, high-protein formula for adult dogs",
        price: 53.00,
        imageUrl: ImgPets1
      },
      {
        id: 2,
        name: "Interactive Toy",
        description: "Puzzle toy that dispenses treats",
        price: 19.00,
        imageUrl: ImgPets2
      },
      {
        id: 3,
        name: "Cat Litter",
        description: "Clumping, odor-control formula",
        price: 16.00,
        imageUrl: ImgPets3
      },
      {
        id: 4,
        name: "Pet Bed",
        description: "Orthopedic memory foam bed for joint support",
        price: 75.00,
        imageUrl: ImgPets4
      },
      {
        id: 5,
        name: "Grooming Kit",
        description: "Complete set with brush, nail clippers, shampoo",
        price: 33.00,
        imageUrl: ImgPets5
      }
    ]
  },
  
  
};

// Loading spinner component
const LoadingSpinner = () => (
    <div className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
);

const HOURS_24 = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const MINUTES_5 = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, '0'));
const selectClass = "px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent focus:bg-white transition-all appearance-none";

const TimeSelect24 = ({ value, onChange, ariaLabel }) => {
    const [hh, mm] = (value || '').split(':');
    const update = (newHH, newMM) => onChange(`${newHH}:${newMM}`);
    return (
        <div className="flex items-center gap-1">
            <select value={hh || ''} onChange={e => update(e.target.value, mm || '00')} className={selectClass} aria-label={`${ariaLabel} hour`}>
                <option value="" disabled>HH</option>
                {HOURS_24.map(h => <option key={h} value={h}>{h}</option>)}
            </select>
            <span className="text-gray-400 font-medium">:</span>
            <select value={mm || ''} onChange={e => update(hh || '00', e.target.value)} className={selectClass} aria-label={`${ariaLabel} minute`}>
                <option value="" disabled>MM</option>
                {MINUTES_5.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
        </div>
    );
};

const CartItem = ({ item, onRemove, onUpdateQuantity, currencySymbol }) => (
    <div className="flex items-start gap-4 p-4 border-b border-gray-100 last:border-b-0">
        <img src={item.imageUrl} alt={item.name} className="w-20 h-24 rounded-lg object-cover" />
        <div className="flex-1">
            <h3 className="font-semibold text-gray-900 mb-3">{item.name}</h3>
            <div className="flex items-center gap-4">
                <button onClick={() => onRemove(item.id)} className="flex items-center gap-1 text-sm text-gray-500 hover:text-black transition-colors">
                    <FiTrash2 size={14} />
                    Remove
                </button>
                <button className="flex items-center gap-1 text-sm text-gray-500 hover:text-black transition-colors">
                    <FiHeart size={14} />
                    Move to wish list
                </button>
            </div>
        </div>
        <div className="text-right">
            <div className="mb-2">
                <label className="block text-sm text-gray-600 mb-1">Quantity</label>
                <input 
                    type="number" 
                    value={item.quantity} 
                    onChange={(e) => onUpdateQuantity(item.id, parseInt(e.target.value))}
                    className="w-16 px-2 py-1 border border-gray-300 rounded text-center"
                    min="1"
                />
            </div>
            <div className="text-right">
                <span className="text-lg font-semibold text-gray-900">{currencySymbol}{(item.price * item.quantity).toFixed(2)}</span>
            </div>
        </div>
    </div>
);

// Business selector component
const BusinessSelector = ({ currentBusiness, onBusinessChange }) => (
    <div className="mb-6">
        <select 
            value={currentBusiness} 
            onChange={(e) => onBusinessChange(e.target.value)}
            className="w-full p-3 bg-white border border-gray-300 rounded-2xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-gray-900 font-medium"
        >
            <option value="parking">Airport Parking</option>
            <option value="offstreetParking">Offstreet Parking</option>
            <option value="automotive">Automotive & Parts</option>
            <option value="burgers">Burger Paradise</option>
            <option value="fashion">Fashion & Apparel</option>
            <option value="beauty">Cosmetics & Beauty</option>
            <option value="electronics">Electronics & Gadgets</option>
            <option value="home">Home Décor & Lifestyle</option>
            <option value="pets">Pet Supplies</option>
           
        </select>
    </div>
);

const CURRENCY_OPTIONS = [
    { label: 'BR - BRL', country: 'BR', currency: 'BRL', symbol: 'R$' },
    { label: 'US - USD', country: 'US', currency: 'USD', symbol: '$' },
    { label: 'AU - AUD', country: 'AU', currency: 'AUD', symbol: 'A$' },
    { label: 'UK - GBP', country: 'GB', currency: 'GBP', symbol: '£' },
    { label: 'EU - EUR', country: 'DE', currency: 'EUR', symbol: '€' },
];

const COUNTRY_DEFAULTS = {
    US: {
        addressLine1: "123 Main Street",
        city: "New York",
        region: "NY",
        postalCode: "10001",
        phoneNumber: "+12125551234"
    },
    AU: {
        addressLine1: "100 George Street",
        city: "Sydney",
        region: "NSW",
        postalCode: "2000",
        phoneNumber: "+61412345678"
    },
    GB: {
        addressLine1: "10 Downing Street",
        city: "London",
        region: "London",
        postalCode: "SW1A 2AA",
        phoneNumber: "+442071234567"
    },
    BR: {
        addressLine1: "Av Paulista 1000",
        city: "São Paulo",
        region: "SP",
        postalCode: "01310-100",
        phoneNumber: "+5511912345678"
    },
    DE: {
        addressLine1: "Unter den Linden 1",
        city: "Berlin",
        region: "Berlin",
        postalCode: "10117",
        phoneNumber: "+4930123456789"
    }
};

const CurrencySelector = ({ value, onChange }) => (
    <div className="mb-6">
        <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="w-full p-3 bg-white border border-gray-300 rounded-2xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-gray-900 font-medium"
        >
            {CURRENCY_OPTIONS.map((opt) => (
                <option key={opt.currency} value={opt.currency}>{opt.label}</option>
            ))}
        </select>
    </div>
);


export default function ShoppingCart() {
    const navigate = useNavigate();
    const [currentBusiness, setCurrentBusiness] = useState('parking');
    const [items, setItems] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isCheckoutLoading, setIsCheckoutLoading] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState(() => {
        return localStorage.getItem('selectedCurrency') || 'USD';
    });
    const [merchantId, setMerchantId] = useState(() => {
        return localStorage.getItem('merchantId') || '';
    });

    const handleMerchantIdChange = (value) => {
        setMerchantId(value);
        localStorage.setItem('merchantId', value);
    };
    const [arrivalDate, setArrivalDate] = useState('');
    const [arrivalTime, setArrivalTime] = useState('');
    const [departureDate, setDepartureDate] = useState('');
    const [departureTime, setDepartureTime] = useState('');

    const apiCheckout = useRef(new ApiCheckout());
    
    const handleCurrencyChange = (currency) => {
        setSelectedCurrency(currency);
        localStorage.setItem('selectedCurrency', currency);
    };

    const currencySymbol = (CURRENCY_OPTIONS.find(o => o.currency === selectedCurrency) || CURRENCY_OPTIONS[1]).symbol;
    
    // Get current business configuration
    const config = BUSINESS_CONFIGS[currentBusiness];
    const availableItems = config.products;

    // Reset cart when business type changes
    const handleBusinessChange = (newBusiness) => {
        setCurrentBusiness(newBusiness);
        setItems([]); // Clear cart when switching business types
        setErrorMessage(null);
    };

    // Create display config based on current business - matching your original structure
    const displayConfig = {
        fontFamily: 'Arial, sans-serif',
        primaryColor: String(config.primaryColor || '#3B82F6'),
        secondaryColor: String(config.secondaryColor || '#8f8f8f'),
        theme: 'light',
        pageTitle: String(config.businessName || ''),
        footerText: String(config.footerText || ''),
        headerText: String(config.headerText || ''),
        logoUrl: String(config.logoUrl || ''),
        showCart: false,
        showAmounts: false,
        showHeaderBar: false,
        showFooterBar: false,
        showBackToCartButton: false,
        backToCartButtonLabel: 'Back to Cart',
        showPayButton: true,
        payButtonLabel: 'Pay Now'
    };

    useEffect(() => {

    }, []);

    const addItem = (itemToAdd) => {
        const found = items.find(item => item.id === itemToAdd.id);
        if (found) {
            setItems(items.map(item => item.id === itemToAdd.id ? { ...item, quantity: item.quantity + 1 } : item));
        } else {
            setItems([...items, { ...itemToAdd, quantity: 1 }]);
        }
    };

    const removeItem = (id) => {
        setItems(items.filter(item => item.id !== id));
    };

    const updateQuantity = (id, newQuantity) => {
        if (newQuantity < 1) return;
        setItems(items.map(item => item.id === id ? { ...item, quantity: newQuantity } : item));
    };

    const cartTotal = items.reduce((total, item) => total + item.price * item.quantity, 0);

    // Offstreet parking total calculation
    const offstreetDurationHrs = (() => {
        if (currentBusiness !== 'offstreetParking' || !arrivalDate || !arrivalTime || !departureDate || !departureTime) return 0;
        const ms = new Date(`${departureDate}T${departureTime}`) - new Date(`${arrivalDate}T${arrivalTime}`);
        return ms > 0 ? Math.ceil(ms / 3600000) : 0;
    })();
    const offstreetRate = BUSINESS_CONFIGS.offstreetParking.hourlyRate;
    const offstreetTotal = offstreetDurationHrs * offstreetRate;
    const total = currentBusiness === 'offstreetParking' ? offstreetTotal : cartTotal;
    const isOffstreet = currentBusiness === 'offstreetParking';

    const handleProceedToCheckout = async () => {
        setErrorMessage(null);
        setIsCheckoutLoading(true);
        
        try {
            const lineItemList = items
                .filter(item => item.quantity > 0)
                .map((item) => {
                    const product = availableItems.find((p) => p.id === item.id);
                    if (product) {
                        return {
                            lineItem: product.name, // Use product name as lineItem
                            lineItemDescription: product.description, // Use product description
                            quantity: item.quantity,
                            lineItemCost: (product.price * item.quantity).toFixed(2), // Total cost for this line item
                            lineItemImageUrl: product.imageUrl // Add image URL
                        };
                    }
                    return null;
                })
                .filter((item) => item !== null);

            // TODO: Collect billing address from user before checkout
            // For now using placeholder data - replace with actual user input
            const currencyOption = CURRENCY_OPTIONS.find(opt => opt.currency === selectedCurrency) || CURRENCY_OPTIONS[1];
            const orderData = {
                lineItemList,
                country: currencyOption.country,
                currency: currencyOption.currency,
                subtotal: total.toFixed(2),
                tax: "0.00"
            };

            const countryDefaults = COUNTRY_DEFAULTS[currencyOption.country] || COUNTRY_DEFAULTS.US;

            const customerData = {
                firstName: "John",
                lastName: "Doe",
                email: "john.doe@example.com",
                phoneNumber: countryDefaults.phoneNumber
            };

            const billingAddressData = {
                firstName: "John",
                lastName: "Doe",
                addressLine1: countryDefaults.addressLine1,
                addressLine2: "",
                city: countryDefaults.city,
                region: countryDefaults.region,
                postalCode: countryDefaults.postalCode,
                country: currencyOption.country
            };

            // For parking, create session then go to parking checkout with the session
            if (currentBusiness === 'parking') {
                const sessionResponse = await apiCheckout.current.CheckoutCreateSession(orderData, displayConfig, customerData, billingAddressData, merchantId || null);
                navigate("/parkingcheckout", {
                    state: {
                        paymentSession: {
                            sessionId: sessionResponse.data.sessionId,
                            orderData: orderData
                        },
                        bookingData: {
                            items: items.map(item => {
                                const product = availableItems.find(p => p.id === item.id);
                                return { ...product, quantity: item.quantity };
                            }),
                            total,
                            country: currencyOption.country,
                            currency: currencyOption.currency
                        }
                    }
                });
                return;
            }

            // For offstreet parking, create session then go to offstreet checkout
            if (currentBusiness === 'offstreetParking') {
                // Create a line item for offstreet parking since products array is empty
                const offstreetOrderData = {
                    ...orderData,
                    lineItemList: [{
                        lineItem: "Offstreet Parking",
                        lineItemDescription: `${offstreetDurationHrs} hours @ ${currencySymbol}${offstreetRate.toFixed(2)}/hr`,
                        quantity: 1,
                        lineItemCost: offstreetTotal.toFixed(2),
                        lineItemImageUrl: ImgOffstreeParking1
                    }]
                };
                const sessionResponse = await apiCheckout.current.CheckoutCreateSession(offstreetOrderData, displayConfig, customerData, billingAddressData, merchantId || null);
                navigate("/offstreetparkingcheckout", {
                    state: {
                        paymentSession: {
                            sessionId: sessionResponse.data.sessionId,
                            orderData: offstreetOrderData
                        },
                        bookingData: {
                            arrivalDate, arrivalTime, departureDate, departureTime,
                            durationHrs: offstreetDurationHrs,
                            hourlyRate: offstreetRate,
                            total: offstreetTotal,
                            country: currencyOption.country,
                            currency: currencyOption.currency
                        }
                    }
                });
                return;
            }

            const sessionResponse = await apiCheckout.current.CheckoutCreateSession(orderData, displayConfig, customerData, billingAddressData, merchantId || null);

            navigate("/checkout", {
                state: { 
                    paymentSession: {
                        sessionId: sessionResponse.data.sessionId,
                        orderData: orderData
                    },
                    currency: currencyOption.currency
                }
            });
            
        } catch (error) {
            console.error(error);
            setErrorMessage("Failed to create checkout session. Please try again.");
        } finally {
            setIsCheckoutLoading(false);
        }
    };

    return (
        <div className="max-w-7xl mx-auto p-4">
            <div className="flex flex-col md:flex-row md:space-x-4">
                <div className="w-full md:w-2/3 p-4">
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium mb-4">
                            <FiShoppingBag className="w-4 h-4 mr-2" />
                            {config.badgeText || `${config.businessName} Online Store`}
                        </div>
                        <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
                            {config.headingPrefix || 'Shop'}
                            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent"> {config.headingHighlight || 'Online'}</span>
                        </h1>
                        <p className="text-lg text-gray-600 mt-2">{config.headerText}</p>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {isOffstreet ? (
                            <div className="col-span-full bg-white border border-gray-200 rounded-3xl p-8 shadow-sm max-w-xl mx-auto w-full">
                                <img src={ImgOffstreeParking1} alt="Offstreet car park" className="w-full h-44 object-cover rounded-2xl mb-6" />
                                <h3 className="text-lg font-semibold text-gray-900 mb-6">Select your parking times</h3>

                                {/* Entry row */}
                                <div className="mb-5">
                                    <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 text-left">Entry</label>
                                    <div className="flex gap-3">
                                        <input type="date" value={arrivalDate} onChange={e => setArrivalDate(e.target.value)}
                                            className="flex-1 px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent focus:bg-white transition-all" aria-label="Entry date" />
                                        <TimeSelect24 value={arrivalTime} onChange={setArrivalTime} ariaLabel="Entry" />
                                    </div>
                                </div>

                                {/* Exit row */}
                                <div className="mb-5">
                                    <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 text-left">Exit</label>
                                    <div className="flex gap-3">
                                        <input type="date" value={departureDate} onChange={e => setDepartureDate(e.target.value)}
                                            className="flex-1 px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent focus:bg-white transition-all" aria-label="Exit date" />
                                        <TimeSelect24 value={departureTime} onChange={setDepartureTime} ariaLabel="Exit" />
                                    </div>
                                </div>

                                {offstreetDurationHrs > 0 && (
                                    <div className="mt-2 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl p-4 flex items-center justify-between">
                                        <div>
                                            <p className="text-sm font-semibold text-gray-900">{Math.floor(offstreetDurationHrs / 24) > 0 ? `${Math.floor(offstreetDurationHrs / 24)}d ${offstreetDurationHrs % 24}h` : `${offstreetDurationHrs}h`}</p>
                                            <p className="text-xs text-gray-500">{currencySymbol}{offstreetRate.toFixed(2)}/hr</p>
                                        </div>
                                        <p className="text-xl font-bold text-indigo-700">{currencySymbol}{offstreetTotal.toFixed(2)}</p>
                                    </div>
                                )}
                            </div>
                        ) : (
                        availableItems.map(item => (
                            <div key={item.id} className="bg-white border border-gray-200 rounded-3xl p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col">
                                <div className='flex justify-center items-center'>
                                <img src={item.imageUrl} alt={item.name} className="w-full h-40 object-cover rounded-3xl" />
                                </div>
                                <div className="mt-4 flex flex-col flex-1">
                                    <h5 className="text-lg font-semibold text-gray-900">{item.name}</h5>
                                    <p className="text-sm text-gray-600 mt-1">{item.description}</p>
                                    <div className="mt-auto pt-3">
                                        <p className="text-lg font-semibold text-gray-900">{currencySymbol}{item.price.toFixed(2)}</p>
                                        <button onClick={() => addItem(item)} className="mt-3 w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-2 px-4 rounded-full border border-gray-300 transition-colors">
                                            Add to Cart
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                        )}
                    </div>
                </div>

                <div className="w-full md:w-1/3 p-4">
                    {/* Controls */}
                    <div className="flex flex-col gap-3 mb-6">
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider pl-1">Store</label>
                            <select
                                value={currentBusiness}
                                onChange={(e) => handleBusinessChange(e.target.value)}
                                className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl shadow-sm text-sm text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            >
                                <option value="parking">Airport Parking</option>
                                <option value="offstreetParking">Offstreet Parking</option>
                                <option value="automotive">Automotive & Parts</option>
                                <option value="burgers">Burger Paradise</option>
                                <option value="fashion">Fashion & Apparel</option>
                                <option value="beauty">Cosmetics & Beauty</option>
                                <option value="electronics">Electronics & Gadgets</option>
                                <option value="home">Home Décor & Lifestyle</option>
                                <option value="pets">Pet Supplies</option>
                            </select>
                        </div>
                        <div className="flex gap-3">
                            <div className="flex flex-col gap-1 flex-1">
                                <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider pl-1">Currency</label>
                                <select
                                    value={selectedCurrency}
                                    onChange={(e) => handleCurrencyChange(e.target.value)}
                                    className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl shadow-sm text-sm text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                                >
                                    {CURRENCY_OPTIONS.map((opt) => (
                                        <option key={opt.currency} value={opt.currency}>{opt.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="flex flex-col gap-1 flex-1">
                                <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider pl-1">Merchant ID</label>
                                <input
                                    type="text"
                                    value={merchantId}
                                    onChange={(e) => handleMerchantIdChange(e.target.value)}
                                    placeholder="Optional"
                                    className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl shadow-sm text-sm text-gray-900 font-medium placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="text-center mb-6">
                        <h2 className="text-3xl font-bold text-gray-900 leading-tight">
                            Shopping
                            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent"> Cart</span>
                        </h2>
                    </div>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                        {isOffstreet ? (
                            offstreetDurationHrs > 0 ? (
                                <div className="p-4 border-b border-gray-100">
                                    <h3 className="font-semibold text-gray-900">Offstreet Parking</h3>
                                    <p className="text-sm text-gray-600">{offstreetDurationHrs}h @ {currencySymbol}{offstreetRate.toFixed(2)}/hr</p>
                                    <p className="text-lg font-semibold text-gray-900 mt-1">{currencySymbol}{offstreetTotal.toFixed(2)}</p>
                                </div>
                            ) : (
                                <p className="p-6 text-center text-gray-500">Select entry and exit times to continue.</p>
                            )
                        ) : items.length > 0 ? items.map(item => (
                            <CartItem 
                                key={item.id} 
                                item={item} 
                                onRemove={removeItem} 
                                onUpdateQuantity={updateQuantity}
                                currencySymbol={currencySymbol}
                            />
                        )) : (
                            <p className="p-6 text-center text-gray-500">Your cart is empty.</p>
                        )}
                    </div>
                    
                    {/* Checkout Summary */}
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mt-4">
                        <div className="space-y-3">
                            <div className="flex justify-between text-gray-600">
                                <span>Temporary amount</span>
                                <span className="font-semibold">{currencySymbol}{total.toFixed(2)}</span>
                            </div>
                            {currentBusiness !== 'parking' && currentBusiness !== 'offstreetParking' && (
                            <div className="flex justify-between text-gray-600">
                                <span>Shipping</span>
                                <span className="font-semibold">Free</span>
                            </div>
                            )}
                            <div className="border-t pt-3">
                                <div className="flex justify-between">
                                    <span className="text-lg font-semibold text-gray-900">Total (incl. tax)</span>
                                    <span className="text-lg font-semibold text-gray-900">{currencySymbol}{total.toFixed(2)}</span>
                                </div>
                            </div>
                        </div>
                        
                        {/* Show error message if checkout fails */}
                        {errorMessage && (
                            <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                                {errorMessage}
                            </div>
                        )}
                        
                        <button 
                            className={`mt-6 w-full py-3 px-4 rounded-full font-medium transition-colors duration-200 border ${
                                isCheckoutLoading || (isOffstreet ? offstreetDurationHrs === 0 : items.length === 0)
                                    ? 'bg-gray-200 border-gray-300 cursor-not-allowed text-gray-400' 
                                    : 'bg-gray-100 border-gray-300 hover:bg-gray-200 text-gray-700'
                            }`}
                            onClick={handleProceedToCheckout}
                            disabled={isCheckoutLoading || (isOffstreet ? offstreetDurationHrs === 0 : items.length === 0)}
                        >
                            {isCheckoutLoading ? (
                                <>
                                    <LoadingSpinner />
                                    Processing...
                                </>
                            ) : (
                                'GO TO CHECKOUT'
                            )}
                        </button>

                        {/* Promo Code Section */}
                        <div className="mt-6 pt-6 border-t border-gray-200">
                            <h3 className="font-medium text-gray-900 mb-3">Apply promo code</h3>
                            <div className="flex gap-2">
                                <input 
                                    type="text" 
                                    placeholder="Promo code" 
                                    className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                                <button className="px-4 py-2 bg-gray-100 border border-gray-300 rounded-full text-gray-700 font-medium hover:bg-gray-200 transition-colors">
                                    APPLY
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}